import { Listing } from '@/utils/platform-api/__generated__/graphql';

/** Split a string into alternating text and numeric segments for natural sort */
function naturalChunks(s: string): (string | number)[] {
  const chunks: (string | number)[] = [];
  let i = 0;
  while (i < s.length) {
    const rest = s.slice(i);
    const numMatch = rest.match(/^\d+/);
    if (numMatch) {
      chunks.push(parseInt(numMatch[0], 10));
      i += numMatch[0].length;
    } else {
      const nonNumMatch = rest.match(/^\D+/);
      if (nonNumMatch) {
        chunks.push(nonNumMatch[0]);
        i += nonNumMatch[0].length;
      } else {
        /* c8 ignore next 2 - Defensive fallback; regex branches above cover all characters */
        i += 1;
      }
    }
  }
  return chunks;
}

function compareNatural(a: string, b: string): number {
  const chunksA = naturalChunks(a);
  const chunksB = naturalChunks(b);
  const len = Math.max(chunksA.length, chunksB.length);
  for (let i = 0; i < len; i++) {
    const segA = chunksA[i];
    const segB = chunksB[i];
    if (segA === undefined) return -1;
    if (segB === undefined) return 1;
    if (typeof segA === 'number' && typeof segB === 'number') {
      if (segA !== segB) return segA - segB;
    } else {
      const strA = String(segA);
      const strB = String(segB);
      const cmp = strA.localeCompare(strB);
      if (cmp !== 0) return cmp;
    }
  }
  return 0;
}

export const sortListingsByName = (items: Listing[]): Listing[] => {
  return items.sort((a, b) => {
    const nameA = a.name?.toLowerCase();
    const nameB = b.name?.toLowerCase();
    if (!nameA) return -1;
    if (!nameB) return 1;
    return compareNatural(nameA, nameB);
  });
};
